import * as React from "react";
import {Tab} from "semantic-ui-react";
import { LongRunningQueries } from "./LongRunningQueries";
import {useContext} from "react";
import { ConfigContext } from "../../../context/ConfigContext";
import {clampTabIndex} from "../../../context/TabSession";
import {Migrations} from "./Migrations";

export interface MongoHealthProps {
    history: any
}

const panes = [
    {pane: null, menuItem: 'LongRunningQueries', render: () => <LongRunningQueries/>},
    {pane: null, menuItem: 'Migrations', render: () => <Migrations/>},
]

export function MongoHealth(props: MongoHealthProps) {

    const context = useContext(ConfigContext);

    const [activeIndex, setActiveIndex] = React.useState(clampTabIndex(context.tabSession.mongoHealthTab, panes));

    // Context handling
    function setContextTab(tabIndex: number) {
        context.setSingleTabSession(
            "mongoHealthTab",
            tabIndex,
            null,
            null
        )
    }

    return <>
        <Tab
        id={"MongoHealthTabview"}
        class={"flexTab"}
        panes={panes}
        activeIndex={activeIndex}
        onTabChange={(_, data) => {
            let index = parseInt(data.activeIndex.toString());
            console.log("[MongoHealthTabview] onTabChange", index);
            setContextTab(index);
            setActiveIndex(index);
        }}/>
    </>;
}